import { errors } from 'redux-rest-reducer';

import { ACTIONS as logoutActions } from '@~/actions/logout';
import { ACTIONS as trialHomeAction } from '@~/actions/trial-home';

const initialState = {
  currentPageConfig: {},
  trialDetails: {},
  activeTrialState: '',
  activeTrialPageId: '',
  isStale: false,
  isLoaded: false,
  isLoading: false,
  isLoadingFailed: false,
};

export default function RestReducer(state = initialState, { type, payload }) {
  if (type === trialHomeAction.GET) {
    return {
      ...state,
      isStale: false,
      isLoaded: false,
      isLoading: true,
      isLoadingFailed: false,
    };
  }

  if (type === trialHomeAction.GET_SUCCESS) {
    const { value: trialHomeData } = payload;

    const { demo_info: demoInfo, trial_states: demoTrialStates = [] } =
      trialHomeData || {};

    const { trial_details: trialDetails, program_id: programId } = demoInfo || {};
    const {
      trial_state: trialState = 'intro',
      trial_page_id: trialPageId = 'teacher_intro',
      trial_modal_id: trialModalId = '',
      selected_regular_slots: selectedRegularSlots = [],
      selected_timezone: selectedTimezone = '',
    } = trialDetails || {};

    const trialStatePageList =
      demoTrialStates.length > 0
        ? demoTrialStates.find(demotrial => demotrial?.trial_state === trialState)?.pages
        : [];

    const currentPageConfig =
      trialStatePageList?.find(trialPage => trialPage.page_id === trialPageId) || {};

    return {
      ...state,
      trialDetails: trialHomeData,
      activeTrialState: trialState,
      activeTrialPageId: trialPageId,
      activeModalId: trialModalId,
      currentProgramId: programId,
      selectedRegularSlots,
      selectedTimezone,
      currentPageConfig,
      isStale: false,
      isLoaded: true,
      isLoading: false,
      isLoadingFailed: false,
    };
  }

  if (type === trialHomeAction.UPDATE_CONFIG) {
    const { activeTrialState, activeTrialPageId } = payload;

    const { trialDetails } = state || {};
    const { trial_states: demoTrialStates = [] } = trialDetails || {};

    const trialStatePages =
      demoTrialStates.length > 0
        ? demoTrialStates.find(demotrial => demotrial?.trial_state === activeTrialState)
            ?.pages
        : [];

    const currentPageConfig =
      trialStatePages?.find(trialPage => trialPage.page_id === activeTrialPageId) || {};

    return {
      ...state,
      ...payload,
      isStale: false,
      currentPageConfig,
    };
  }

  if (type === trialHomeAction.INVALIDATE_ITEM) {
    return {
      ...state,
      isStale: true,
    };
  }

  if (type === logoutActions.POST_SUCCESS || type === errors[401]) {
    return initialState;
  }

  return state;
}
